
import React, { useState, useRef, useEffect } from "react";
import { Form, Button, Collapse } from "react-bootstrap";
import { FaAngleDown } from "react-icons/fa";

const GeographyComponent = ({
  options,
  handleCheckChange,
  selectedGeographyItems,
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  // Function to handle click outside the component
  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Form ref={ref}>
      <Button
        onClick={() => setOpen(!open)}
        aria-controls="example-collapse-text"
        aria-expanded={open}
        variant="default"
        style={{
          backgroundColor: "white",
          width: "190px",
          height: "50px",
          padding: "11.5px 10px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontSize: "1rem",
            fontWeight: "360",
          }}
        >
          <span>
            {selectedGeographyItems.length !== 0 ? (
              <>
                {selectedGeographyItems.length === 1 ? (
                  <span> {selectedGeographyItems[0]} </span>
                ) : (
                  <span> ({selectedGeographyItems.length}) selected </span>
                )}
              </>
            ) : (
              <>Select Geography</>
            )}
          </span>
          <FaAngleDown
            style={{
              transform: open ? "rotate(180deg)" : "rotate(0)", // Rotate the icon based on the dropdown state
              transition: "transform 0.3s ease-in-out", // Add transition for smooth animation
            }}
          />
        </div>
      </Button>
      <Collapse
        style={{
          position: "absolute",
          backgroundColor: "white",
          width: "190px",
          zIndex: 1,
        }}
        in={open}
      >
        <div id="example-collapse-text">
          <Form.Group controlId="exampleForm.SelectCustom">
            {options && options && options.map((option) => (
              <Form.Check
                style={{ fontSize: "0.85rem", fontWeight: "600" }}
                key={option}
                type="checkbox"
                label={option?.name}
                className={`mb-2 customData`}
                disabled={['Weekly', 'Monthly', 'Yearly'].includes(option)}
                checked={selectedGeographyItems.includes(option?.name)}
                onChange={(event) => handleCheckChange(option?.name)}
              />
            ))}
          </Form.Group>
        </div>
      </Collapse>
    </Form>
  );
};

export default GeographyComponent;
